/**
 * The query-key factory (plan §9.1).
 *
 * **Nothing outside this file may construct a query key.** Keys are
 * hierarchical so invalidation can name a subtree — `queryKeys.nooks.all()`
 * invalidates every list and every detail — which is only possible while every
 * key is built here.
 *
 * Block 00e shipped one entry. `mcpTokens` and the rest arrive
 * with the hooks that need them.
 *
 * `nooks.list` takes filters from block 03 rather than from block 19, which is
 * where filters are actually implemented: a key that has to grow a segment
 * later invalidates every cached list on the day it does.
 */
export const queryKeys = {
    health: () => ["health"],
    me: () => ["me"],
    nooks: {
        /** Every list and every detail. */
        all: () => ["nooks"],
        /** Every list, whatever its filters — the invalidation target after a write. */
        lists: () => ["nooks", "list"],
        list: (filters) => ["nooks", "list", filters ?? {}],
        detail: (id) => ["nooks", "detail", id],
        sites: () => ["nooks", "sites"],
    },
    ask: {
        /** Every Ask entry. */
        all: () => ["ask"],
        /** Block 42's history list. */
        threads: () => ["ask", "threads"],
        thread: (id) => ["ask", "thread", id],
    },
    channels: {
        all: () => ["channels"],
    },
    mcpTokens: {
        all: () => ["mcpTokens"],
    },
    uat: {
        all: () => ["uat"],
    },
    storage: {
        /** Bytes used and allowed. Invalidated by every successful upload. */
        usage: () => ["storage", "usage"],
    },
};
//# sourceMappingURL=query-keys.js.map